export const SectionHeading = ({ eyebrow, title, description, light = false, testId }) => (
  <div data-testid={testId} className="max-w-2xl">
    {eyebrow && (
      <p className={`eyebrow mb-4 ${light ? "text-accent" : "text-primary"}`}>{eyebrow}</p>
    )}
    <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-[1.1] ${light ? "text-white" : "text-foreground"}`}>
      {title}
    </h2>
    {description && (
      <p className={`mt-5 text-base md:text-lg font-light leading-relaxed ${light ? "text-white/70" : "text-muted-foreground"}`}>
        {description}
      </p>
    )}
  </div>
);
